import { LobbyImage } from '@colonist/types';
import { UIMMatchmakingSearchingView } from './UIMMatchmakingSearchingView.ts';
import { createShuffleQueueIconStack } from '../../../../../../../shared/scripts/matchmaking/ShuffleQueueUtils.ts';
import { ClientShuffleQueueController } from '../../../../../../../shared/scripts/shuffle/ClientShuffleQueueController.ts';
import { createDivIn, createImgIn } from '../../../../../../../shared/scripts/ui_utils/DomUtils.ts';
import { MatchmakingMatchTypes } from '@colonist/game-base-types';
export class UIMMatchmakingSearchingShuffleView extends UIMMatchmakingSearchingView {
    addTitle() {
        super.addTitle();
        this.setTimeElapsedCounter();
    }
    addImage() {
        const shuffleQueueData = ClientShuffleQueueController.shuffleQueueData;
        if (shuffleQueueData == undefined) {
            super.addImage();
            return;
        }
        const shuffleSearchImageContainer = createDivIn(this.mainContent, 'm-matchmaking-search-image');
        const stackedIcon = createShuffleQueueIconStack(shuffleQueueData.mapId, shuffleQueueData.modeId);
        if (stackedIcon) {
            stackedIcon.classList.add('m-gamemode-img');
            shuffleSearchImageContainer.appendChild(stackedIcon);
        }
        createImgIn(shuffleSearchImageContainer, LobbyImage.MatchmakingSearch, 'm-gamemode-search-icon');
    }
    constructor(matchmakingController){
        const loadingText = {
            key: 'strings:homePage.matchmakingPopup.searchingForOpponents'
        };
        const title = {
            key: 'strings:homePage.unranked.shuffle'
        };
        const imageSrc = LobbyImage.GameModeShuffle;
        super(matchmakingController, title, imageSrc, loadingText, MatchmakingMatchTypes.UnrankedShuffle);
    }
}
